import { Modal } from "@/components";
import React from "react";
import FormAddMember from "./FormAddMember";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  roomId: number;
}

const ModalAddMember: React.FC<Props> = ({ open, onOpenChange, roomId }) => {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title="メンバーを追加"
      overflowScroll={false}
      isStopPropagationOnModal={false}
    >
      <FormAddMember onClose={() => onOpenChange(false)} roomId={roomId} />
    </Modal>
  );
};

export default ModalAddMember;
